module.exports = __webpack_public_path__ + "static/img/btn_3.e24fc470.jpg";